import AdminLoginForm from "../../components/Auth/AdminLoginForm";
import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import AuthLayout from "../../components/Layout/AuthLayout";

const AdminLogin = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <AuthLayout
      title={language ? "Log in" : "Log in"}
      showLanguageToggle={false}
    >
      <AdminLoginForm />
    </AuthLayout>
  );
};

export default AdminLogin;
